/**
 * 앱 진입점.
 *
 * 화면을 그리기 전에 **로그인 복원**을 기다린다. 담아 둔 토큰이 아직 살아 있는지는
 * 서버만 알기 때문에(`GET /admin/me`), 기다리지 않으면 끊긴 토큰으로 화면에 들어가
 * 첫 요청에서 401 이 난다. 반대로 살아 있는 토큰인데 기다리지 않으면 새로고침할 때마다
 * 로그인 화면이 한 번 스쳐 지나간다. (2026-10-20 까지는 Firebase 복원을 기다렸다 — DB #88)
 */
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import ko from 'element-plus/es/locale/lang/ko'
import 'element-plus/dist/index.css'

import App from './App.vue'
import router from './router'
import { whenAuthReady } from './utils/auth'
import './assets/base.css'
import './assets/renewal-theme.css'

/**
 * 리뉴얼 디자인 시안(design/renewal-theme 브랜치) — 모양만 입힌다.
 * 주소에 `?theme=old` 를 붙이면 예전 모양, `?theme=renewal` 이면 다시 시안. 고른 것은 브라우저에 기억한다.
 */
function applyTheme() {
  const q = new URLSearchParams(location.search).get('theme')
  try {
    if (q) localStorage.setItem('admin.theme', q)
  } catch {
    // 저장소를 못 쓰는 창이면 이번만 적용
  }
  let t = q
  try {
    t = t || localStorage.getItem('admin.theme')
  } catch {
    // 위와 같다
  }
  document.documentElement.classList.toggle('renewal', t !== 'old')
}
applyTheme()

/**
 * Element Plus 한국어 문구 — 틀린 곳만 바로잡는다.
 *
 * 숫자 입력의 증가/감소 버튼 이름이 **뒤바뀌어** 들어 있다(2.11.7 기준):
 * 아래 화살표(decrease)가 '값 증가', 위 화살표(increase)가 '값 감소' 로 읽힌다.
 * 스크린 리더와 마우스를 올렸을 때 보이는 이름이 반대가 된다.
 */
const koLocale = {
  ...ko,
  el: {
    ...ko.el,
    inputNumber: { ...ko.el.inputNumber, decrease: '값 감소', increase: '값 증가' },
  },
}

async function bootstrap() {
  await whenAuthReady()
  createApp(App).use(router).use(ElementPlus, { locale: koLocale }).mount('#app')
}

bootstrap()
